import { useState, useEffect, useContext } from "react";
import "../Scss/CaseStyles.scss?v=1.1.4";
import { Box, Fade, Grid, LinearProgress, Skeleton } from "@mui/material/";

import {
  CommonSubHeader,
  formatToTenDigits,
  quitarTildes,
  b64DecodeUnicode,
} from "../../Components/helpers/Helpers";

// SECTIONS
// SECTION N|1
import InfoSection from "../ViewSections/InfoSection";
// SECTION N|2
import ConfigControlSection from "../ViewSections/ConfigControlSection";
// SECTION N|3
import TabsSection from "../ViewSections/TabsSection";
// SECTION N|4 ACORDION
import FlowSectionAccordion from "../ViewSections/FlowSectionAccordion";
import api from "../../api/axios";
import { useSearchParams } from "react-router-dom";
import PropTypes from "prop-types";
import { PermissionContext } from "../../Components/Context/Context";
import Unauthorized from "../../Components/Common/Design/Unauthorized";

const ViewCase = () => {
  const Swal = require("sweetalert2");

  const [searchParams] = useSearchParams();
  const caseId = searchParams.get("id");
  const { can } = useContext(PermissionContext);
  const hasPermission = can("cases", "view");

  const [progress, setProgress] = useState(10);
  const [redOn, setRedOn] = useState(false);
  const [yellowOn, setYellowOn] = useState(false);
  const [greenOn, setGreenOn] = useState(false);
  const [flag, setFlag] = useState(false);
  const [userLogged, setUserLogged] = useState(false);

  const [updatedCase, setUpdatedCase] = useState(false);
  const [lawyersList, setLawyersList] = useState([]);

  // DATA CASE
  const [dataCase, setDataCase] = useState({
    peritaje: 0,
    apud_acta: 0,
    expiration: 0,
  });

  const [caseContract, setCaseContract] = useState({});
  const [acceptedContract, setAcceptedContract] = useState("");

  const [lawyerData, setLawyerData] = useState({
    email: "",
    name: "",
    province: "",
    address: "",
    postalCode: "",
    document: "",
    phone: "",
  });

  const [clientData, setClientData] = useState({
    email: "",
    name: "",
    province: "",
    address: "",
    postalcode: "",
    document: "",
    phone: "",
  });
  // DATA CASE

  // CONTACT CONDITIONS
  const [contactConditionIfExist, setContactConditionIfExist] = useState("");
  const [mailTemplates, setMailTemplates] = useState(null);

  // PRINCIPAL INFO
  const getDataCase = async () => {
    // setFlag(false);
    const url = `${process.env.REACT_APP_API_URL}/cases/show`;

    try {
      const response = await api.post(url, { id: caseId });

      console.log(response);

      const {
        //  Identificadores Principales
        id,
        case_type_name,
        //  Relaciones con Usuarios y Empresas
        company_name,
        clients_relation,
        //  Datos del Caso
        case_contract_relation,
        case_asociation_name,
        cases_flow_relation,
        last_task,
        previous_case_statuses_relation,
        cases_notes_relation,
        cases_alerts_relation,
        peritaje,
        apud_acta,
        expiration,
        //  Información del Flujo del Caso
        full_case_status_name,
        full_client_name,
        full_lawyer_name,
        full_office_name,
        //  Relación con Profesionales
        lawyers_relation,
        company_relation,
        types_relation,
        //  Fechas y Actualizaciones
        trial_date,
        last_update,
        // Otros Datos
        inss_users,
        transfer_id,
      } = response.data.case[0];

      const formattedNumber = formatToTenDigits(id);

      setLawyersList(response?.data?.lawyersList);

      if (clients_relation?.id) {
        const url = `${process.env.REACT_APP_API_URL}/contacts/search`;

        const formData = new FormData();
        formData.append(
          "document",
          clients_relation?.nif ? clients_relation?.nif : "",
        );
        formData.append(
          "email",
          clients_relation?.email ? clients_relation?.email : "",
        );

        const responseSearch = await api.post(url, formData);

        console.log(responseSearch);

        if (responseSearch?.data?.contacts?.length > 0) {
          if (responseSearch?.data?.contacts?.length == 1) {
            const { condiciones: contactConditions } =
              responseSearch.data.contacts[0];

            const textConditions =
              contactConditions?.trim() != ""
                ? contactConditions
                : "Sin condiciones asignadas";

            setContactConditionIfExist(contactConditions);
          } else {
            setContactConditionIfExist(
              "Existen multiples contactos, por favor revise la información del contacto actual y elimine los sobrantes.",
            );
          }
        }
      }

      let totalTasksProgress = 0;

      if (response?.data?.case_tasks?.length > 0) {
        console.log(response.data.case_tasks, "response.data.case_tasks");
        response.data.case_tasks.forEach((element) => {
          if (element?.config && "firma" in element.config) {
            setAcceptedContract(b64DecodeUnicode(element.config.firma));
          }

          // Asegurar que unicamente lea los registros con estado en 1 -> "completo" ya que pueden haber duplicados inutiles que pueden aumentar la cuenta de las tasks.
          if (element?.status == 1) {
            totalTasksProgress++;
          }
        });
      }

      // Se calcula el progreso con las tasks completadas vs el numero total de tasks del expediente con una regla de 3.
      if (previous_case_statuses_relation?.length >= totalTasksProgress) {
        const previous = previous_case_statuses_relation?.length ?? 0;
        const realTaskNumber = totalTasksProgress ?? 0;
        const porcentaje = previous > 0 ? (realTaskNumber * 100) / previous : 0;

        setProgress(Math.round(porcentaje));
      }

      setMailTemplates(response.data.company_mail_templates);

      setUserLogged(response?.data?.user_logged);

      const sortedStatuses = [...previous_case_statuses_relation].sort(
        (a, b) => a.order - b.order,
      );

      const oldFlowStatus = [];

      const taskName = quitarTildes(
        cases_flow_relation?.status_name?.toLowerCase(),
      );
      const exceptions = ["firma", "revision"];
      const isException =
        exceptions?.includes(taskName) || !taskName.includes("finalizado");

      console.log(taskName);

      sortedStatuses?.forEach((element) => {
        if (element.order <= cases_flow_relation.order || isException) {
          response?.data?.case_tasks?.forEach((task) => {
            if (task.task_id == element.id) {
              oldFlowStatus.push(element);
            }
          });
        }
      });

      if (!isException) {
        oldFlowStatus.shift();
      }

      oldFlowStatus.unshift({ id: 0, status_name: "Seleccionar" });

      console.log(oldFlowStatus);

      const count = sortedStatuses?.length - 1;
      let penultimate = sortedStatuses[count - 1];

      setDataCase({
        id: id,
        case_type_name,
        case_id: formattedNumber,
        alerts: cases_alerts_relation,
        notes: cases_notes_relation,
        peritaje,
        apud_acta,
        expiration,
        status_name: full_case_status_name,
        task: last_task,
        penultimateTask: penultimate,
        tasks: response.data.case_tasks,
        completeFlow: sortedStatuses,
        flow: cases_flow_relation,
        last_update,
        old_states: oldFlowStatus,
        transfer_id,
        trial_date,
        clients_relation,
        full_client_name,
        full_lawyer_name,
        full_office_name,
        lawyers_relation,
        company_relation,
        company_name,
      });

      setLawyerData({
        id: lawyers_relation.id,
        name: full_lawyer_name,
        office: full_office_name,
        company: company_name,
        association: case_asociation_name,
      });

      setClientData({
        id: clients_relation?.id,
        name: full_client_name,
        document: clients_relation?.nif,
        phone: clients_relation?.phone,
        email: clients_relation?.email,
        address: clients_relation?.address,
        province: clients_relation?.province,
        postalcode: clients_relation?.postalcode,
      });

      const text = case_contract_relation.contract;
      const htmlText = text.replace(/\n/g, "<br>");

      const tagValues = {
        "#NOMBRE#": `<b>${clients_relation?.name}</b>`,
        "#APELLIDOS#": `<b>${clients_relation?.surname}</b>`,
        "#DIRECCION#": `<b>${clients_relation?.address}</b>`,
        "#PROVINCIA#": `<b>${clients_relation?.province}</b>`,
        "#DNI#": `<b>${clients_relation?.nif}</b>`,
      };

      // Se reemplazan los tags para colocar los datos reales del cliente en el contrato
      const resultReplaceTags = htmlText.replace(
        /#(\w+)#/g,
        (_, key) => tagValues[`#${key}#`] || key,
      );

      var signCurrentStatus;

      if (response?.data?.case_tasks?.length > 0) {
        response.data.case_tasks.forEach((element) => {
          console.log(element);
          if (element?.config && "firma" in element.config) {
            setAcceptedContract(b64DecodeUnicode(element.config.firma));
            signCurrentStatus = element.config;
          }
        });
      }

      console.log(signCurrentStatus);

      setCaseContract({
        firmaUsuario: signCurrentStatus,
        contract: resultReplaceTags,
        contractTitle: case_contract_relation.contract_title,
        contractAcceptData: {
          client_name: full_client_name,
          client_nif: clients_relation.nif,
          company_name: case_contract_relation.company_relation.company_name,
          client_ip: response?.data?.ip ? response.data.ip : "0.0.0.0",
        },
      });
    } catch (error) {
      console.error("Error fetching user data:", error); // Mensaje de error más descriptivo
    } finally {
      setFlag(true); // Asegurarse de desactivar la bandera en caso de error o éxito
      Swal.close();
    }
  };
  // PRINCIPAL INFO

  // ======================================================
  // COMPONENTE INTERNO: LinearProgress con etiqueta
  // ======================================================

  const LinearProgressWithLabel = (props) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <b className="infoStyle" style={{ marginRight: "10px" }}>
          Progreso:
        </b>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress color="success" variant="determinate" {...props} />
        </Box>
        {props.value}%
      </Box>
    );
  };

  LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
  };

  useEffect(() => {
    getDataCase();
  }, [updatedCase]);

  const bgColor = "#e2e3eaa2";

  const generalStyles = {
    width: "100%",
    background: bgColor,
    borderRadius: "4px",
    mb: "10px",
  };

  const content = (
    <Fade timeout={1000} in={flag}>
      <div>
        <Grid container item xs={12} md={11} m={"auto"} sx={generalStyles}>
          <InfoSection
            lawyerData={lawyerData}
            clientData={clientData}
            dataCase={dataCase}
            contactConditionIfExist={contactConditionIfExist}
            lawyersList={lawyersList}
            setUpdatedCase={setUpdatedCase}
            updatedCase={updatedCase}
          />
        </Grid>
        <Grid container item xs={12} md={11} m={"auto"} mb={"10px"}>
          <Grid item xs={12}>
            <LinearProgressWithLabel value={progress} sx={{ height: "14px" }} />
          </Grid>
        </Grid>
        <Grid container item xs={12} md={11} m={"auto"} sx={generalStyles}>
          <ConfigControlSection
            dataCase={dataCase}
            caseId={caseId}
            setDataCase={setDataCase}
            z
            progress={progress}
            onFinish={() => console.log("terminado!")}
            setUpdatedCase={setUpdatedCase}
            updatedCase={updatedCase}
          />
        </Grid>
        <Grid container item xs={12} md={11} m={"auto"} sx={generalStyles}>
          <TabsSection
            caseId={caseId}
            lawyerData={lawyerData}
            dataCase={dataCase}
            onFinish={() => console.log("terminado!")}
          />
        </Grid>
        <Grid container item xs={12} md={11} m={"auto"} sx={generalStyles}>
          <FlowSectionAccordion
            setFlag={setFlag}
            flag={flag}
            dataCase={dataCase}
            caseContract={caseContract}
            acceptedContract={acceptedContract}
            caseId={caseId}
            userLogged={userLogged}
            mailTemplates={mailTemplates}
            updatedCase={updatedCase}
            setUpdatedCase={setUpdatedCase}
          />
        </Grid>
      </div>
    </Fade>
  );

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Expedientes" subTitle="Ver" />

      {!hasPermission && <Unauthorized />}

      {flag === false && (
        <Grid container item xs={12} md={11} m={"auto"}>
          <Grid item xs={12} sx={{ marginBottom: "15px" }}>
            <Skeleton
              width={"100%"}
              height={370}
              style={{ transform: "none" }}
            />
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: "15px" }}>
            <Skeleton
              width={"100%"}
              height={270}
              style={{ transform: "none" }}
            />
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: "15px" }}>
            <Skeleton
              width={"100%"}
              height={470}
              style={{ transform: "none" }}
            />
          </Grid>
        </Grid>
      )}

      {hasPermission && content}
    </div>
  );
};

export default ViewCase;
